import { toast } from 'sonner';
import { useRef, useEffect } from 'react';

import { resetBackendFailures, subscribeBackendErrors } from 'src/lib/error-reporter';

// ----------------------------------------------------------------------

const TOAST_ID = 'backend-error-monitor';
const TOAST_COOLDOWN_MS = 30_000;

export function BackendErrorMonitor() {
  const lastShownAt = useRef(0);

  useEffect(() => {
    const unsubscribe = subscribeBackendErrors(({ count, lastFailure }) => {
      const now = Date.now();
      if (now - lastShownAt.current < TOAST_COOLDOWN_MS) return;
      lastShownAt.current = now;

      const statusLabel = lastFailure.status === 0 ? 'offline / unreachable' : lastFailure.status;

      toast.error(`Backend is having trouble (${count} failures)`, {
        id: TOAST_ID,
        description: `${lastFailure.method} ${lastFailure.url} → ${statusLabel}. Our team has been notified.`,
        duration: 8000,
        action: {
          label: 'Retry',
          onClick: () => {
            resetBackendFailures();
            if (typeof window !== 'undefined') window.location.reload();
          },
        },
      });
    });

    return unsubscribe;
  }, []);

  return null;
}
